import { render, staticRenderFns } from "./CampaignPolicy.vue?vue&type=template&id=78f432ae&scoped=true"
import script from "./CampaignPolicy.vue?vue&type=script&lang=js"
export * from "./CampaignPolicy.vue?vue&type=script&lang=js"
import style0 from "./CampaignPolicy.vue?vue&type=style&index=0&id=78f432ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f432ae",
  null
  
)

export default component.exports